"use strict";
/**
 * 期权上交所 深交所
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageOptionA = void 0;
var react_1 = __importDefault(require("react"));
var crumbs_1 = require("../crumbs");
var quotetable_1 = require("../quotetable");
var qiquantab_1 = require("./shared/qiquantab");
/**
 * 沪深期权（push2）
 */
function PageOptionA() {
    // const location = useLocation()
    // let hash = location.hash
    return (react_1.default.createElement("div", { className: "pageopt" },
        react_1.default.createElement(crumbs_1.CrumbsWithRefresh, null),
        react_1.default.createElement(qiquantab_1.CustomQiQuanMainTab2, null),
        react_1.default.createElement(quotetable_1.QuoteTable, null)));
}
exports.PageOptionA = PageOptionA;
